'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useIsOverflowGroupVisible", {
    enumerable: true,
    get: function() {
        return useIsOverflowGroupVisible;
    }
});
const _overflowContext = require("./overflowContext");
function useIsOverflowGroupVisible(id) {
    return (0, _overflowContext.useOverflowContext)((ctx)=>ctx.groupVisibility[id]);
}
